import styled from 'styled-components';

export const StyledButton = styled.div`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary.blue};
  cursor: pointer;
`;

export const MiniJobDocumentContainer = styled.div`
  display: flex;
  flex-direction: column;
  .form-item-select {
    width: 100%;
    max-width: 288px;
  }
`;
